import {
    SET_INFORMATIVE_SESSION,
    SET_INFORMATIVE_SESSIONS,
    SET_PAST_SESSION,
    SET_REMINDER_SESSION,
    SET_SESSION_URL
} from "./constants";
import {globalCatch} from "../../../_services/global-catch";
import {svcNoticeService} from "../../../_services/notice-service";

export const setInformativeSessions = payload => ({ type: SET_INFORMATIVE_SESSIONS, payload });
export const setInformativeSession = payload => ({ type: SET_INFORMATIVE_SESSION, payload });
export const setPastEvents = payload => ({ type: SET_PAST_SESSION, payload });
export const setReminderSession = payload => ({ type: SET_REMINDER_SESSION, payload });
export const setSessionURL = payload => ({ type: SET_SESSION_URL, payload });

export const fetchInformativeSessions = () => globalCatch.catch(async (dispatch) => {
    const informativeSessions = await (await svcNoticeService()).getNextEvents();
    dispatch(setInformativeSessions(informativeSessions));
});

export const fetchInformativeSession = (uuid) => globalCatch.catch(async (dispatch) => {
    const informativeSession = await (await svcNoticeService()).getEventDetails(uuid);
    dispatch(setInformativeSession(informativeSession));
});

export const fetchPastSessions = () => globalCatch.catch(async (dispatch) => {
    const pastSession = await (await svcNoticeService()).getPastEvents();
    dispatch(setPastEvents(pastSession));
});

export const createReminder = (uuid, minutes) => globalCatch.catch(async (dispatch) => {
    const reminder = await (await svcNoticeService()).createReminder(uuid, minutes);
    dispatch(setReminderSession(reminder));
});

export const getSessionURL = (uuid) => globalCatch.catch(async (dispatch) => {
    console.log('ALEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEXAAAAAAAANDRU: ')
    const url = await (await svcNoticeService()).getEventUrl(uuid);
    setTimeout(() => {
        console.log('UUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUURRRRRRRRRRRRRLLLLLLLLLL: ', url);
    }, 0);
    dispatch(setSessionURL(url));
    return url;
});
